import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/magic-academy/2024/Index.vue')
const Ranking = () => import('../activity/magic-academy/2024/Ranking.vue')
const Rewards = () => import('../activity/magic-academy/2024/Rewards.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/magic-academy/2024',
  name: 'activity_magic_academy_2024',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '魔法学院杯',
    expiryDate: '2024-11-04',
  },
}

export const rankingRoute: RouteConfig = {
  path: '/activity/magic-academy/2024/ranking',
  name: 'activity_magic_academy_2024_ranking',
  component: Ranking,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '学分总榜',
    expiryDate: '2024-11-04',
  },
}

export const rewardsRoute: RouteConfig = {
  path: '/activity/magic-academy/2024/rewards',
  name: 'activity_magic_academy_2024_rewards',
  component: Rewards,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '我的奖品',
    expiryDate: '2024-11-04',
  },
}

export default []
